import React from "react";
import "../style/navbar.css";
import mujImg from "../assets/logoMUJ.png";
import { useAuth } from "../context/AuthContext";
import { useNavigate, useLocation } from "react-router-dom";

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isuserloggedin, setIsuserloggedin, role, setToken } = useAuth();

  // Do not render the student floating navbar on admin routes
  if (
    location.pathname.startsWith("/admin") ||
    location.pathname === "/admin-login" ||
    (location.pathname === "/" && role === "admin")
  ) {
    return null;
  }

  const handleLogout = () => {
    localStorage.removeItem("login");
    setIsuserloggedin(false);
    setToken(null);
    navigate("/login");
  };

  return (
    <div className='navbar-full'>
      <nav>
        <img
          src={mujImg}
          alt='MUJ'
          className='muj-img'
          onClick={() => navigate("/")}
          style={{ cursor: "pointer" }}
        />
        <ul className='nav-items'>
          {isuserloggedin && (
            <li
              onClick={() => {
                if (role === "admin") {
                  navigate("/admin");
                } else {
                  navigate("/");
                }
              }}
            >
              {role === "admin"
                ? "Admin Panel"
                : role === "department"
                ? "Department Dashboard"
                : "Dashboard"}
            </li>
          )}

          {!isuserloggedin && (
            <li onClick={() => navigate("/login")}>Student Login</li>
          )}

          <li onClick={() => navigate("/contact")}>Contact</li>
          <li onClick={() => navigate("/faq")}>FAQ</li>
          <li onClick={() => navigate("/alumni-reg")}>Alumni</li>



          {isuserloggedin && (
            <li onClick={handleLogout} style={{ color: "#ef4444" }}>
              Logout
            </li>
          )}
        </ul>
      </nav>
    </div>
  );
};

export default Navbar;
